import { styled } from 'libs/ui/styled';
// eslint-disable-next-line no-restricted-imports
import { Link } from 'react-router-dom';

export const LinkStyled = styled(Link)(() => ({
  textDecoration: 'none',
}));
